











import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as api from '@/api'
import LoadingScreen from '@/views/components/LoadingScreen.vue'
import debounce from 'lodash/debounce';
import Cookies from 'js-cookie'

export default Vue.extend({
  components: {
    LoadingScreen
  },
  data() {
    return {
      fixedTop: 0,
      isFirstLoadingAuthUser: true,
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'authUser', 'isLoggingOut']),
    needsLoggedIn(): boolean {
      return !this.$route.matched.some((record: any) => record.meta.needsLoggedIn === false) // default: true
    },
    needsSupport(): boolean {
      return Boolean(this.$route.matched.some((record: any) => record.meta.needsSupport)) // default: false
    },
    updateIsMobileScreen() {
      return debounce(() => {
        this.$store.dispatch('updateIsMobileScreen')
      }, 50)
    },
  },
  watch: {
    '$route.name'() {
      this.checkLoggedIn()
    },
    isLoggedIn(val: boolean) {
      this.checkLoggedIn()
    },
  },
  async created() {
    // check logged in
    try {
      await this.$store.dispatch('loadAuthUser')
      this.checkLoggedIn()
      await this.$store.dispatch('updateShowPurchase')
    } catch(e) {
      // Do nothing
    }
    this.isFirstLoadingAuthUser = false
  },
  async mounted() {
    this.updateIsMobileScreen()
    window.addEventListener('focus', this.focus)
    window.addEventListener('resize', this.updateIsMobileScreen)

    const country = await api.country.getCountry()
    const iOS = (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod']
      .includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) // iPad on iOS 13 detection
          
    if (country === 'CN' && !iOS) {
      this.$store.dispatch('loadChinaApk')
    } else if (country === 'CN' && iOS) {
      this.$store.dispatch('setIosCn')
    }
    this.track();
  },
  destroyed() {
    window.removeEventListener('focus', this.focus)
    window.removeEventListener('resize', this.updateIsMobileScreen)
  },
  methods: {
    track () {
      if (this.authUser) {
        this.$gtag.config({'GA_MEASUREMENT_ID': { user_id: this.authUser.user_id }});
        if (this.authUser.country) {
          this.$gtag.set({
            'user_country': this.authUser.country,
          })
        }
      }
    },
    async checkLoggedIn() {
      const vm = this as any
      // do not redirect
      if (['NotFoundPage'].includes(this.$route.name)) return
      
      // redirect
      if (this.needsLoggedIn && !vm.isLoggedIn) {
        if (vm.isLoggingOut) {
          // Do not redirect on normal logout, make transition manually
          return
        }
        const redirectPath = this.$route.fullPath as string
        const query = { 'redirect-path': redirectPath }
        this.$router.push({
          name: 'Login',
          query,
        })
      } else if (!this.needsLoggedIn && vm.isLoggedIn) {
        if (this.$route.query['redirect-path'] && this.$route.fullPath !== this.$route.query['redirect-path']) {
          this.$router.push(this.$route.query['redirect-path'])
        } else if (!vm.isLoggedIn) {
          this.$router.push({
            name: 'Login',
          })
        }
      } else if (this.needsLoggedIn && vm.isLoggedIn) {
        if (this.authUser && this.$route.name === 'DeleteUserConfirm') {
          return;
        }
        if (!this.authUser.country && this.$route.name !== 'SelectRegion') {
          this.$router.push({
            name: 'SelectRegion',
          }).catch();
          return;
        }
        if (this.authUser && !this.authUser.is_email_valid && this.$route.name !== 'ChangeEmail') {
          this.$router.push({
            name: 'ChangeEmail',
            query: {
              error: 'invalid_email'
            }
          }).catch();
          return;
        }
        if (vm.needsSupport) {
          const user = await api.support.checkUserIsSupport().catch(() => {
            this.$router.push({
              name: 'Login',
            })
          })
        }
      }
    },
    async focus() {
      if (this.isFirstLoadingAuthUser) return

      const oldId = (this as any).authUser?.id as string | undefined
      const isUpdatingMmemory = Cookies.get('updatingMemory');
      if (isUpdatingMmemory) {
        return;
      }
      await this.$store.dispatch('loadAuthUser')
      const newId = (this as any).authUser?.id as string | undefined
      if (!newId) {
        // If you are not logged in now and have problems, 
        // watch.isLoggedIn will redirect so no need to do anything
        return
      }
      if (oldId !== newId) {
        location.reload()
      }
    },
  },
})
